
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipMinimisedIec as ObiOwnShipMinimisedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-minimised-iec.js';
 
 
 

 
 export const ObiOwnShipMinimisedIec = createComponent({
   react: React,
   tagName: 'obi-own-ship-minimised-iec',
   elementClass: ObiOwnShipMinimisedIecElement,
   events: {
     
   }
  });
 
 